import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { updateStatus } from "../../actions/userActions";
import { useNavigate } from "react-router-dom";
import "./changeStatus.sass";
export default function ChangeStatus() {
  const { i18n, t } = useTranslation();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [progressList, setProgressList] = useState([]);

  const { loading, statusData, error } = useSelector((state) => ({
    loading: state.user.loading,
    statusData: state.user.statusData,
    error: state.user.error,
  }));

  useEffect(() => {
    // 將多語系資料拉進來放到courseData
    let data = t(`course.tab`, { returnObjects: true }).map((item) => item);
    let tempData = [];
    data.forEach((item, index) => {
      item.card.forEach((card, cardIndex) => {
        tempData.push({ ...card, num: `${index + 1}-${cardIndex + 1}` });
      });
    });

    // 創建一個映射 tempData 的 course_no 到其對應的資料
    const tempDataMap = new Map(tempData.map((item) => [item.course_no, item]));

    // 結合資料
    const combinedData = statusData.user_progress.map((item) => ({
      ...item,
      ...tempDataMap.get(item.course_no), // 使用 Map 來獲取對應的 tempData
    }));

    console.log(`output->courseData`, combinedData);

    setProgressList(combinedData);
  }, [i18n.language, statusData]); // 依賴於當前語言環境

  // useEffect(() => {
  //   if (statusData) {
  //     console.log(`output->statusData`, statusData.user_progress);
  //     setProgressList([...statusData.user_progress]);
  //   }
  // }, [statusData]);

  const handleFetchClick = async () => {
    // 將 progressList 映射到期望的 user_progress 格式
    const updatedUserProgress = progressList.map((progress) => ({
      id: progress.id,
      name: progress.name,
      type: progress.type,
      progress: progress.progress, // 確保只有 progress 字段被更新
      bearSetId: progress.bearSetId,
      course_id: progress.course_id,
      course_no: progress.course_no,
      completionDate: progress.completionDate,
    }));

    // 創建 statusData 的深拷貝，並更新 user_progress
    const updatedStatusData = {
      ...statusData,
      user_progress: updatedUserProgress,
    };

    // 打印新的狀態數據以確認
    console.log(updatedStatusData);

    // 使用更新後的數據觸發 Redux action
    const success = await dispatch(updateStatus(updatedStatusData));

    if (success) {
      navigate("/");
    } else {
      console.error("Failed to update status");
    }
  };

  const handleProgressChange = (index, newProgress) => {
    setProgressList(
      progressList.map((progress, i) => {
        if (i === index) {
          return { ...progress, progress: newProgress };
        }
        return progress;
      }),
    );
  };

  const handleResetClick = async () => {
    // 創建 statusData 的深拷貝，並更新 user_progress
    const updatedStatusData = {
      ...statusData,
      bear_type: null,
      bear_set: statusData.bear_set.map((set) => {
        return { categoryId: set.categoryId, equipment: [], isLock: true };
      }),
      user_progress: statusData.user_progress.map((progress) => {
        return { ...progress, progress: 0 };
      }),
    };

    // 打印新的狀態數據以確認
    console.log(updatedStatusData);

    // 使用更新後的數據觸發 Redux action
    const success = await dispatch(updateStatus(updatedStatusData));

    if (success) {
      navigate("/");
    } else {
      console.error("Failed to update status");
    }
  };

  return (
    <div className="change-status">
      {loading && <div>Loading...</div>}
      {error && <div>Error: {error}</div>}
      {statusData && (
        <div className="box">
          <h2>User Progress</h2>
          {progressList.map((progress, index) => (
            <div key={index} className="list">
              <p>
                {progress.num}｜{progress.course_no}｜{progress.title}:{" "}
                <select
                  value={progress.progress}
                  onChange={(e) =>
                    handleProgressChange(index, parseInt(e.target.value))
                  }
                  disabled={progress.progress === 2}
                >
                  <option value={0}>未上課</option>
                  <option value={1}>已上課</option>
                  <option value={2}>已領取</option>
                </select>
              </p>
            </div>
          ))}
          <button onClick={handleFetchClick}>修改上課狀態</button>
          <button onClick={handleResetClick}>重置資料</button>
        </div>
      )}
    </div>
  );
}
